import { render, staticRenderFns } from "./BaseUnitSelect.vue?vue&type=template&id=434f3244&"
import script from "./BaseUnitSelect.vue?vue&type=script&lang=js&"
export * from "./BaseUnitSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports